
import React from 'react';

const ProjectsSection: React.FC = () => {
  const projects = [
    {
      title: "Brooklyn Bridge Rehabilitation Project",
      location: "New York City, New York",
      services: [
        "Comprehensive surface preparation inspection",
        "Multi-coat system application oversight",
        "Environmental compliance monitoring",
        "Quality documentation and reporting",
        "Final coating system verification"
      ],
      image: "https://public.readdy.ai/ai/img_res/c9ab01507e8cf1b4ff8601470ec770bb.jpg"
    },
    {
      title: "Manhattan Bridge Rehabilitation Project",
      location: "New York, New York",
      services: [
        "Bridge structure coating inspection services",
        "Exterior coating system evaluation",
        "Corrosion protection system testing",
        "Coating failure analysis and remediation",
        "Long-term maintenance planning"
      ],
      image: "https://readdy.ai/api/search-image?query=Manhattan%20Bridge%20steel%20structure%20with%20coating%20inspection%20professionals%20conducting%20quality%20control%20testing%20on%20protective%20coating%20systems%20with%20specialized%20equipment%20in%20New%20York&width=400&height=300&seq=project-manhattan&orientation=landscape"
    },
    {
      title: "JFK Terminal Infrastructure Project",
      location: "Queens, New York",
      services: [
        "Airport terminal coating inspection",
        "Specialized infrastructure coating evaluation",
        "High-performance coating system verification",
        "Environmental impact assessment",
        "Comprehensive project documentation"
      ],
      image: "https://readdy.ai/api/search-image?query=Modern%20JFK%20airport%20terminal%20infrastructure%20with%20steel%20structures%20and%20coating%20inspection%20team%20examining%20protective%20coatings%20with%20professional%20inspection%20equipment%20at%20Queens%20New%20York&width=400&height=300&seq=project-jfk&orientation=landscape"
    }
  ];

  return (
    <section className="py-20 bg-gray-50">
      <div className="container mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="text-4xl font-bold text-gray-900 mb-6">
            Featured Coating Inspection Projects
          </h2>
          <p className="text-xl text-gray-700 max-w-3xl mx-auto leading-relaxed">
            Explore our portfolio of successful coating inspection projects that demonstrate our expertise and commitment to excellence across diverse industries and applications.
          </p>
        </div>
        
        <div className="grid lg:grid-cols-3 gap-8">
          {projects.map((project, index) => (
            <div key={index} className="bg-white rounded-lg shadow-lg overflow-hidden hover:shadow-xl transition-shadow">
              <img 
                src={project.image}
                alt={project.title}
                className="w-full h-64 object-cover object-top"
              />
              <div className="p-6">
                <h3 className="text-xl font-semibold text-gray-900 mb-2">
                  {project.title}
                </h3>
                <p className="text-blue-600 font-medium mb-4">
                  {project.location}
                </p>
                <ul className="space-y-2">
                  {project.services.map((service, serviceIndex) => (
                    <li key={serviceIndex} className="flex items-start space-x-2">
                      <i className="ri-check-line text-blue-600 text-sm mt-1 flex-shrink-0"></i>
                      <span className="text-gray-700 text-sm">{service}</span>
                    </li>
                  ))}
                </ul>
                <button className="mt-6 bg-blue-600 hover:bg-blue-700 text-white px-6 py-2 rounded-lg text-sm font-semibold transition-colors whitespace-nowrap cursor-pointer">
                  Learn More
                </button>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ProjectsSection;
